const STORAGE_KEY = "seiva_support_open"

// Client-side helpers for Support Chat:
//   - sync open state to localStorage (informational; server is source of truth)
//   - Esc closes the panel
//   - Enter on the textarea submits the form; Shift+Enter inserts a newline
const SupportChat = {
  mounted() {
    this.handleEvent("support:state_changed", ({ open }) => {
      localStorage.setItem(STORAGE_KEY, open ? "true" : "false")
    })

    this._onKeyDown = (event) => {
      if (event.key === "Escape") {
        const panel = this.el.querySelector(`#${this.el.id}-panel`)
        if (!panel) return
        this.pushEventTo(this.el, "close_support", {})
        return
      }
    }
    window.addEventListener("keydown", this._onKeyDown)

    // Submit on Enter / newline on Shift+Enter, scoped to the textarea inside this widget.
    this._onTextareaKeyDown = (event) => {
      if (event.key !== "Enter" || event.shiftKey || event.isComposing) return
      const ta = event.target
      if (!(ta instanceof HTMLTextAreaElement)) return
      if (!this.el.contains(ta)) return
      const form = ta.closest("form")
      if (!form) return
      event.preventDefault()
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit()
      } else {
        form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }))
      }
    }
    this.el.addEventListener("keydown", this._onTextareaKeyDown)
  },

  destroyed() {
    if (this._onKeyDown) {
      window.removeEventListener("keydown", this._onKeyDown)
    }
    if (this._onTextareaKeyDown) {
      this.el.removeEventListener("keydown", this._onTextareaKeyDown)
    }
  }
}

export default SupportChat
